export default "__VITE_ASSET__OoKKoDrs__"